import React, { useEffect } from "react";
import AOS from "aos";
import Contact from "./component/pages/Contact";
import LegalPage, { LEGAL_PAGES } from "./component/pages/LegalPage";
import Header from "./component/inc/Header";
import Home from "./component/pages/Home";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Footer from "./component/inc/Footer";
import ScrollToTop from "./component/inc/ScrollToTop";
import { CmsProvider } from "./component/cms/Cms";

function ScrollToTopMain() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // A header menu item clicked on another page brings us back home with
    // the section to show; wait until the home page has rendered it.
    const target = pathname === "/" && state && state.scrollTo;
    if (!target) {
      window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(target);
      if (el || ++tries > 40) {
        clearInterval(timer);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
    return () => clearInterval(timer);
  }, [pathname, state]);

  return null;
}

function App() {
  // The header and footer use AOS animations on every page, not only on the
  // home page (which also initialises AOS); without this they stayed invisible
  // on « Contact » and the legal pages.
  useEffect(() => {
    AOS.init({ once: true, duration: 750, easing: "ease-out-cubic", offset: 40 });
  }, []);

  return (
    <Router basename={"/"}>
      <CmsProvider>
        <ScrollToTopMain />
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path={LEGAL_PAGES.privacy.path} element={<LegalPage page="privacy" />} />
          <Route path={LEGAL_PAGES.terms.path} element={<LegalPage page="terms" />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <ScrollToTop />
      </CmsProvider>
    </Router>
  );
}

export default App;
